import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPaymentMethodVisaLight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 32,
	viewBox: "0 0 48 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_4134_567)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M0 4C0 1.79086 1.79086 0 4 0H44C46.2091 0 48 1.79086 48 4V28C48 30.2091 46.2091 32 44 32H4C1.79086 32 0 30.2091 0 28V4Z",
				fill: "url(#paint0_linear_4134_567)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4 0.25H44C46.0711 0.25 47.75 1.92893 47.75 4V28C47.75 30.0711 46.0711 31.75 44 31.75H4C1.92893 31.75 0.25 30.0711 0.25 28V4C0.25 1.92893 1.92893 0.25 4 0.25Z",
				stroke: "black",
				strokeOpacity: .16,
				strokeWidth: .5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M29.4483 11C26.8923 11 24.6079 12.325 24.6079 14.7726C24.6079 17.5798 28.6591 17.7737 28.6591 19.1841C28.6591 19.778 27.9787 20.3095 26.8162 20.3095C25.1668 20.3095 23.9341 19.5668 23.9341 19.5668L23.4065 22.0371C23.4065 22.0371 24.8267 22.6645 26.7121 22.6645C29.5067 22.6645 31.7059 21.2746 31.7059 18.7849C31.7059 15.8184 27.6378 15.6303 27.6378 14.3214C27.6378 13.8562 28.1964 13.3467 29.3553 13.3467C30.6631 13.3467 31.7297 13.8868 31.7297 13.8868L32.2461 11.5013C32.2461 11.5013 31.085 11 29.4479 11H29.4483ZM6.06198 11.1802L6 11.5402C6 11.5402 7.07532 11.7369 8.04396 12.1297C9.29117 12.5798 9.37982 12.8422 9.58991 13.6559L11.8786 22.4786H14.9467L19.6732 11.1802H16.6123L13.5751 18.862L12.3359 12.3503C12.2223 11.605 11.6465 11.1798 10.942 11.1798H6.06234L6.06198 11.1802ZM20.9041 11.1802L18.5031 22.4786H21.422L23.8144 11.1802H20.9041ZM37.1838 11.1802C36.48 11.1802 36.107 11.5571 35.8335 12.2155L31.5571 22.4786H34.618L35.2101 20.7679H38.9391L39.2991 22.4786H42L39.644 11.1802H37.1838ZM37.582 14.2328L38.4894 18.4724H36.0587L37.5823 14.2328H37.582Z",
				fill: "#1434CB"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_4134_567",
		x1: 0,
		y1: 0,
		x2: 48,
		y2: 32,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", { stopOpacity: .02 }), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopOpacity: .08
		})]
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_4134_567",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 48,
			height: 32,
			fill: "white"
		})
	})] })]
});
export default SvgPaymentMethodVisaLight;
